import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import moment from "moment";
import {
  queryGetCustomerFromCase,
  queryGetLabelsByType,
  mutationAddLabelToCustomer,
  mutationDeleteLabelFromCustomer
} from "Apollo";
import { ShowNotice } from "Store";
import TreeLabelList from "module-common/label-list/TreeLabelList";

export default compose(
  graphql(queryGetCustomerFromCase, { name: "customer" }),
  graphql(queryGetLabelsByType, {
    name: "labelsData",
    options: { variables: { type: "CUSTOMER" } }
  }),
  graphql(mutationAddLabelToCustomer, { name: "mutateAdd" }),
  graphql(mutationDeleteLabelFromCustomer, { name: "mutateDelete" })
)(
  class LabelListCase extends Component {
    state = { treeLabels: [] };

    componentWillReceiveProps(nextProps) {
      const { labelsData: { getLabelTemplates: labelsPicker } } = nextProps;
      const allLabelMap = new Map();
      if (labelsPicker) {
        for (const label of labelsPicker) {
          allLabelMap.set(label.id, {
            label: label.displayName,
            isCollapsed: true,
            value: label,
            children: []
          });
        }
      }

      const treeLabels = [];
      for (const label of allLabelMap.values()) {
        // order in tree
        if (label.value.parentId === -1) {
          treeLabels.push(label);
        } else {
          const select = allLabelMap.get(label.value.parentId);
          if (select) {
            select.children.push(label);
          }
        }
      }
      this.setState({ treeLabels: treeLabels });
    }

    render() {
      const {
        customer: { getCustomerFromCase: customer },
        ...rest
      } = this.props;
      const { treeLabels } = this.state;

      const labels = [];
      if (customer && customer.labels) {
        for (const label of customer.labels) {
          labels.push({
            label: label.labelTemplate.displayName,
            color: "#" + label.labelTemplate.color,
            value: label.labelTemplate
          });
        }
      }

      // sort by order and date
      labels.sort((a, b) => {
        if (a.value.order !== b.value.order) {
          return a.value.order > b.value.order;
        } else {
          return moment(a.value.dateCreated).isAfter(b.value.dateCreated);
        }
      });

      return (
        <TreeLabelList
          labels={labels}
          tree={treeLabels}
          onAdd={this.onAdd}
          onRemove={this.onRemove}
          onChange={treeLabels => this.setState(treeLabels)}
          {...rest}
        />
      );
    }

    onAdd = async label => {
      const {
        customer: { getCustomerFromCase: { id } },
        mutateAdd
      } = this.props;
      try {
        await mutateAdd({
          variables: {
            customerInput: { id: id },
            labels: [{ id: label.value.id }]
          },
          refetchQueries: ["getCustomerFromCase"]
        });
        ShowNotice("label-add-success");
      } catch (error) {
        ShowNotice("label-add-error");
      }
    };

    onRemove = async label => {
      const {
        customer: { getCustomerFromCase: { id } },
        mutateDelete
      } = this.props;
      try {
        await mutateDelete({
          variables: {
            customerInput: { id: id },
            labels: [{ id: label.value.id }]
          },
          refetchQueries: ["getCustomerFromCase"]
        });
        ShowNotice("label-delete-success");
      } catch (error) {
        ShowNotice("label-delete-error");
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/TreeLabelListCustomerWithQueryMutation.js